<div [ngSwitch]="context">
  <div *ngSwitchCase="'modelo'">
    <div class="col-6" *ngIf="opedata">
      <mat-form-field>
        <mat-label>Buscar</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="APPL" #input>
      </mat-form-field>
    </div>

    <!-- Context Menu -->
    <div class="context-menu" *ngIf="showContextMenu" [style.left.px]="contextMenuX" [style.top.px]="contextMenuY">
      <ul class="menu-nuevo">
        <li><a (click)="verModelo()">Ver Modelo</a></li>
        <li><a (click)="verGrafica()">Ver Gráfica</a></li>
      </ul>
    </div>

    <cdk-virtual-scroll-viewport #viewportGestion id="viewportGestion" item [appendOnly]="false" [tvsItemSize]="24"
      [headerHeight]="34" class="wrapper mat-elevation-z2 tableStyle">
      <table cdk-table [dataSource]="opedata" class="table-striped tableStyle">

        <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true" class="sticky-header"></tr>
        <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)" 
          (contextmenu)="mostrarMenu($event, row)"
          [ngClass]="{'selected': row === filaSeleccionada}"></tr>
        <ng-container *ngFor="let tablecol of tableColumns">

          <ng-container [cdkColumnDef]="tablecol.id">
            <th cdk-header-cell *cdkHeaderCellDef="" class="sticky-header">
              {{tablecol.name}}
            </th>
            <td cdk-cell *cdkCellDef="let item" [ngClass]="{'salida': item[tablecol.id] === 'SALIDA ↑' || item[tablecol.id] ===  'SALIDA ↓',
                                                          'entrada': item[tablecol.id] === 'ENTRADA ↑' || item[tablecol.id] ===  'ENTRADA ↓',
                                                          'numero-positivo': item[tablecol.id] > 0,
                                                          'numero-negativo': item[tablecol.id] < 0
                                                          }">
              <ng-container *ngIf="tablecol.isString">
                {{item[tablecol.id]}} <ng-container *ngIf="tablecol.id === 'nombreCompania'">
                  {{item['secType'] === 'CFD' ? ' CFD' : ''}}
                          </ng-container>
              </ng-container>
            <ng-container *ngIf="tablecol.isDate">
                {{item[tablecol.id] | smartDate }}
              </ng-container>
              <ng-container *ngIf="tablecol.isNumber">
                {{item[tablecol.id] |number:'1.2-2'}}
              </ng-container>
            </td>
          </ng-container>
        </ng-container>
      </table>
    </cdk-virtual-scroll-viewport>

  </div>
  <div *ngSwitchCase="'diversificador'">

    <div class="col-6" *ngIf="opedataDiv">
      <mat-form-field>
        <mat-label>Buscar Portfolio Labs</mat-label>
        <input matInput (keyup)="applyFilterDiv($event)" placeholder="APPL" #input>
      </mat-form-field>
    </div>

    <!-- Context Menu for diversificador -->
    <div class="context-menu" *ngIf="showContextMenu" [style.left.px]="contextMenuX" [style.top.px]="contextMenuY">
      <ul class="menu-nuevo">
        <li><a (click)="verModelo()">Ver Modelo</a></li>
        <li><a (click)="verGrafica()">Ver Gráfica</a></li>
      </ul>
    </div>
    <!-- aca hacer la otra tabla -->
    <cdk-virtual-scroll-viewport #viewportGestion id="viewportDiv" item [appendOnly]="false" [tvsItemSize]="24"
      [headerHeight]="34" class="wrapper mat-elevation-z2 tableStyle">
      <table cdk-table [dataSource]="opedataDiv" class="table-striped tableStyle">

        <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true" class="sticky-header"></tr>
        <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)"
          (contextmenu)="mostrarMenu($event, row)"
          [ngClass]="{'selected': row === filaSeleccionada}"></tr>
        <ng-container *ngFor="let tablecol of tableColumns">

          <ng-container [cdkColumnDef]="tablecol.id">
            <th cdk-header-cell *cdkHeaderCellDef="" class="sticky-header">
              {{tablecol.name}}
            </th>
            <td cdk-cell *cdkCellDef="let item" [ngClass]="{'salida': item[tablecol.id] === 'SALIDA',
                                                          'entrada': item[tablecol.id] === 'ENTRADA',
                                                          'numero-positivo': item[tablecol.id] > 0,
                                                          'numero-negativo': item[tablecol.id] < 0
                                                          }">
              <ng-container *ngIf="tablecol.isString">
                {{item[tablecol.id]}}
              </ng-container>
              <ng-container *ngIf="tablecol.isDate">
                {{item[tablecol.id] | smartDate }}
              </ng-container>
              <ng-container *ngIf="tablecol.isNumber">
                {{item[tablecol.id] |number:'1.2-2'}}
              </ng-container>
            </td>
          </ng-container>
        </ng-container>
      </table>
    </cdk-virtual-scroll-viewport>

  </div>

</div>
